const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const year = date.getFullYear();

  return `${year}-${month}-${day}`; // e.g., "02-11-2002"
};

const formatTime = (timeStr) => {
  if (!timeStr) return "";
  return timeStr.slice(0, 5); // returns "HH:MM"
};

export { formatDate, formatTime };
